import React from "react";
import img from "../../../assets/newImages/iof.png"
import "../../pages.css";
import linha from "../../../assets/linha.png";

export default function IofPage() {
  return (
    <article className="art-s mb-5 p-text">
      <section className="row m-0 sectionInit">
        <div className="c-init">
          <div className="c-init__text col-6  d-flex flex-column sect mt-5">
            <p className="fw-bolder text-decoration-underline">
              Mudanças nas regras de IOF
            </p>
            <p>
              As medidas que entraram em vigor em 23 de maio de 2025* trazem
              alterações relevantes no Imposto sobre Operações Financeiras (IOF)
              para pessoa física e impactam produtos como: Câmbio, Previdência
              VGBL e Cartões Internacionais. Elencamos abaixo as principais
              mudanças.
            </p>
            <p>*Diário Oficial, os Decretos nº 12.466/25 e nº 12.467/25</p>
            <div className="div-line">
              <img src={linha} alt="linha de separação"></img>
            </div>

          </div>
          <div className="col-6 c-init__image">
            <img src={img} className="image" alt="grupo-om"></img>
          </div>
        </div>{" "}
        <section>
          <br/>
          <h2 style={{fontSize: 24, textDecoration: "underline"}}>
            <b>Alíquotas do IOF Câmbio</b>
          </h2>
          <br/>
          <h5>
            <b>Alíquota unificada de 3,5% para:</b>
          </h5>
          <ul class="custom-list">
            <li>Compras internacionais com cartões de crédito ou débito;</li>
            <li>
              Cartão pré-pago internacional e cheques de viagem para gastos
              pessoais;
            </li>
            <li>Compra e saque de moeda estrangeira em espécie;</li>
            <li>Empréstimo externo de curto prazo (até 364 dias);</li>
            <li>
              Remessa para o exterior de titularidade própria, ou de seu
              cônjuge, companheiro ou parente, consanguíneo ou afim.
            </li>
          </ul>
        </section>
        <section>
          <p>
            <b>Remessa para conta de investimento no exterior:</b> governo
            estabeleceu previsão específica para as remessas com finalidade de
            investimento no exterior com alíquota de 1,1%.
          </p>
          <br/>
          <h5 >
            <b>Alíquota sem alteração</b>
          </h5>
          <p>
            Transferências relativas a aplicações de fundos no exterior:
            operação era isenta de IOF. O governo chegou a anunciar aumento para
            3,5%, mas voltou atrás e será mantida a alíquota zero.
          </p>

          <br/>
          <h5 >
            <b>Previdência VGBL</b>
          </h5>
          <p>
            A alíquota do IOF foi fixada em 5% nos aportes destinados a novas
            aplicações em previdência VGBL, quando a somatória dos valores
            aportados no mês for superior a R$ 50 mil por CPF (ainda que em
            seguradoras distintas);
          </p>

          <p>
            Ressaltamos que a previdência continua sendo importante na
            construção da reserva de aposentadoria e exige planejamento.
            Lembrando que essa medida não impacta o saldo existente, apenas
            novas aplicações.
          </p>

          <p>
            Segue abaixo uma tabela que consolida as alterações promovidas pelos
            Decretos para pessoa física:
          </p>
        </section>
        <section>
        <table className="table table-hover table-bordered">
  <thead>
    <tr>
      <th>CATEGORIA</th>
      <th>ANTES</th>
      <th>DEPOIS</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Compras Internacionais (Cartão)</td>
      <td>3,38%</td>
      <td>3,5%</td>
    </tr>
    <tr>
      <td>Cheques de viagem / Cartões internacionais pré-pagos</td>
      <td>3,38%</td>
      <td>3,5%</td>
    </tr>
    <tr>
      <td>Compra de Moeda Estrangeira (Espécie)</td>
      <td>1,1%</td>
      <td>3,5%</td>
    </tr>
    <tr>
      <td>Remessas ao Exterior (Disponibilidade)</td>
      <td>1,1%</td>
      <td>3,5%</td>
    </tr>
    <tr>
      <td>Remessa ao Exterior (Investimentos)</td>
      <td>0,38%</td>
      <td>1,1%</td>
    </tr>
    <tr>
      <td>Empréstimos Externos de Curto Prazo (até 364 dias)</td>
      <td>0%</td>
      <td>3,5%</td>
    </tr>
    <tr>
      <td>Entrada de Recursos do Exterior (Regra Geral)</td>
      <td>0,38%</td>
      <td>0,38%</td>
    </tr>
    <tr>
      <td>Remessa de Recursos ao Exterior (Regra Geral)</td>
      <td>0,38%</td>
      <td>3,5%</td>
    </tr>
  </tbody>
</table>

        </section>
      </section>
    </article>
  );
}
